import { render, staticRenderFns } from "./DownloadQueue.vue?vue&type=template&id=e99ce1bc&scoped=true&lang=pug"
import script from "./DownloadQueue.vue?vue&type=script&lang=js"
export * from "./DownloadQueue.vue?vue&type=script&lang=js"
import style0 from "./DownloadQueue.vue?vue&type=style&index=0&id=e99ce1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99ce1bc",
  null
  
)

export default component.exports